module.exports = __webpack_public_path__ + "img/5-0SAP乘云而上.a52de0dc.png";